module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("24jzf"))).then(() => parcelRequire('3ji4Q'));